import { onExtractorSessionActivity } from "common/signalR";
import { listTemplateQueryKey } from "components/ListTemplate";
import { useEffect } from "react";
import { useQueryClient, type QueryFilters } from "@tanstack/react-query";

export const extractorSessionListQueryKey = [listTemplateQueryKey, "extractorSession_List"];

// Matches every cached extractor session list query, regardless of pagination or filter values.
export const extractorSessionListQueryFilter: QueryFilters = {
  predicate: q =>
    Array.isArray(q.queryKey) &&
    q.queryKey[0] === extractorSessionListQueryKey[0] &&
    q.queryKey[1] === extractorSessionListQueryKey[1]
};

// Wires the extractor session activity event into the list query cache. Mount once near the list.
// Each event triggers a full invalidation; the DTO from the event is discarded.
export const useExtractorSessionCacheSync = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const activityRes = onExtractorSessionActivity(() => {
      queryClient.invalidateQueries(extractorSessionListQueryFilter);
    });

    return () => {
      activityRes.removeEvent();
    };
  }, [queryClient]);
};
